import { AgxButton, AgxSpacer } from '@urbanx/agx.ui-components2'

interface ComplianceModalActionButtonsProps {
  currentPage: number
  totalPages: number
  onPrevious: () => void
  onNext: () => void
  onComplete: () => void
  onSaveAndExit: () => void
  completeDisabled?: boolean
}

const ComplianceModalActionButtons = ({
  currentPage,
  totalPages,
  onPrevious,
  onNext,
  onComplete,
  onSaveAndExit,
  completeDisabled = false,
}: ComplianceModalActionButtonsProps) => {
  const showPreviousButton = currentPage !== 0
  const showNextButton = currentPage !== totalPages - 1
  const showCompleteButton = currentPage === totalPages - 1

  return (
    <AgxSpacer
      direction="horizontal"
      fill
      contentJustification="space-between"
      contentAlignment="center"
      gap="xs"
    >
      <AgxButton
        id={'complianceModal-saveAndExit'}
        text={'Save and Exit'}
        variant={'hollow'}
        onClick={onSaveAndExit}
      />
      <AgxSpacer
        direction="horizontal"
        gap="xs"
        contentJustification="end"
        contentAlignment="center"
      >
        {showPreviousButton && (
          <AgxButton
            id={'complianceModal-previous'}
            text={'Previous'}
            variant={'hollow'}
            onClick={onPrevious}
          />
        )}
        {showNextButton && (
          <AgxButton
            id={'complianceModal-next'}
            text={'Next'}
            variant={'primary'}
            onClick={onNext}
          />
        )}
        {showCompleteButton && (
          <AgxButton
            id={'complianceModal-complete'}
            text={'Complete'}
            variant={'primary'}
            onClick={onComplete}
            disabled={completeDisabled}
          />
        )}
      </AgxSpacer>
    </AgxSpacer>
  )
}

export default ComplianceModalActionButtons
